module.exports = __webpack_public_path__ + "static/media/no_code.d6dc1f71.svg";